export default __webpack_public_path__ + "static/media/tr.27e05575.png";